import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EducationStepInterface } from '../../models/interfaces/education-step.interface';
import { StepTypeEnum } from '../../models/enums/step-type.enum';
import { EducationProgressTypeEnum } from '../../models/enums/education-progress.enum';
import {MandatoryMasteringOptionEnum} from "@rsmu/oep-api";
import { DeviceType } from '../../models/interfaces/device-type.type';
import { DeviceWidthService } from '../../services/width.service';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { NgFor, NgIf, NgClass, NgStyle, SlicePipe } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';


@Component({
    selector: 'app-navigation-card-dopo',
    templateUrl: './navigation-card-dopo.component.html',
    styleUrls: ['./navigation-card-dopo.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        NgIf,
        NgClass,
        RouterLink,
        MatIconModule,
        ProgressSpinnerComponent,
        NgStyle,
        SlicePipe,
    ],
})
export class NavigationCardDopoComponent implements OnInit, OnDestroy {

  isCollapsed: boolean = true;
  isPressed: boolean = false;
  deviceType: DeviceType = 'desktop';
  isOpen? = false;
  openBlocks: { [key: number]: boolean } = {};
  private destroy$ = new Subject<void>();

  get stepTypeEnum () {
    return StepTypeEnum;
  }

  get progressTypeEnum () {
    return EducationProgressTypeEnum
  }

  get mandatoryMasteredOptionEnum() {
    return MandatoryMasteringOptionEnum;
  }

  get isCollapsedIndex (): number[] {
    const length = this.step?.blocks?.length ?? 0
    return this.isCollapsed ? [0, 3] : [0, length]
  }

  // get typeLessonTextEnum() {
  //   return 'one';
  // }

  @Input()
  step?: EducationStepInterface

  constructor(private deviceWidth: DeviceWidthService) {

  }


  ngOnInit() {
    this.deviceWidth.getDeviceType$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(type => {
      this.deviceType = type;
    });
  }

  getRoutingLink(block: EducationStepInterface) {
    if(block.type === StepTypeEnum.Step) {
      return ['step', block.id]
    } else {
      return ['step', block.parent?.id]
    }
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.isPressed = !this.isPressed;
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
  }

  toggleBlock(index: number): void {
    this.openBlocks[index] = !this.openBlocks[index];
  }

  getMandatoryOptionText(block: any) {
    switch (block?.progress?.mandatoryOption) {
      case 'RECOMMENDED': {
        return 'Рекомендовано для освоения'
      }
      case 'OPTIONAL': {
        return 'Факультативно для освоения'
      }
      case 'REQUIRED': {
        return 'Обязательно для освоения'
      }
      default: {
        return ''
      }
    }
  }

  // getTypeLessonText(block: any) {
  //   switch (block?.progress?.mandatoryOption) {
  //     case 'one': {
  //       return 'Лекция'
  //     }
  //     case 'two': {
  //       return 'Практическое занятие'
  //     }
  //     case 'three': {
  //       return 'Самостоятельная работа'
  //     }
  //     case 'four': {
  //       return 'Тестирование'
  //     }
  //     case 'five': {
  //       return 'Ситуационная задача'
  //     }
  //     default: {
  //       return ''
  //     }
  //   }
  // }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
